import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./indev.css";

export default class Page404 extends Component {
  render() {
    return (
      <>
        <div style={{ width: "100%", textAlign: "center" }}>
          <h1>mã lỗi 404</h1>
          <span className="span404">
            vui lòng kiểm tra kết nối internet rồi tải lại trang
          </span>
          <div className="container-404">
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/175166/screenshots/4742504/trump_shadowpuppet_800x600_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/14268/screenshots/5888618/swim_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/4859/screenshots/6983786/rate_dr_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/406059/screenshots/3251058/hand_shake_dribbble_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/4859/screenshots/14014843/mc-design5-trailer-dr_1_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/175166/screenshots/10748925/the-spread_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/11408/screenshots/1869337/404_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/5276/screenshots/3572698/losttype_typeface_explore_fonts_kendrickkidd_4_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/407030/screenshots/2572486/2invite_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/108083/screenshots/2159546/surferonacid_800x600_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/548267/screenshots/3250796/rocket_print--dribbble_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/285475/screenshots/1958793/built_for_growth_dribbble_2_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/515705/screenshots/4056971/26056444_2041642092738927_4101921783198777344_n_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/31752/screenshots/2157778/v_dribbble_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/757683/screenshots/11277557/shot_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/475225/screenshots/9440384/run_cycle_dribbble_1_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/41719/screenshots/2010627/home_matches_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/719060/screenshots/11211105/rogers_drib2_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/43342/screenshots/3482014/dribbble_2017_may_dribbble112_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/460659/screenshots/4837675/spotify-800x600_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/3016/screenshots/1946859/mm_deku_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/2534972/screenshots/10760218/2_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/1044993/screenshots/4779380/dog-and-tennis-ball_dribbble-3_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/497743/screenshots/4729026/dark_horse-01-01_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/4540442/screenshots/15986296/bullcapital_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/315734/screenshots/1966511/logo_reveal_01_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/43342/screenshots/3420221/dribbble_2017_apr_dribbble83_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/1906640/screenshots/10286559/compelling-_-co_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/1044993/screenshots/6058636/mariachi_dribbble_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/397346/screenshots/1430506/paperclip_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/1044993/screenshots/11918320/adventure-dog_dribbble_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/6063/screenshots/4483992/e_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/59947/screenshots/4895173/fotl_splits_still.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/1044993/screenshots/13636827/duck_dribbble_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/43342/screenshots/4630068/worldcup2018_nigeria_2d_dribbble_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/336943/screenshots/2913789/lufthansa-dreamscapes-icons_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/31752/screenshots/2872268/dunn_s_motors_skull_v4_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/31752/screenshots/3370424/explore_patch_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/31752/screenshots/3252892/chimney_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/167977/screenshots/2251112/dribbble_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/22069/screenshots/2936311/type_hike_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/31664/screenshots/2269610/car_still.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/22679/screenshots/2126281/elementsdrib_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/59100/screenshots/1966486/sunset_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/31664/screenshots/1407208/page-gif_still.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/337778/screenshots/5317641/illos-small_1x.gif"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/52084/screenshots/3739940/gfds_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/22679/screenshots/2328246/tigre-elements_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/120724/screenshots/3507475/night-move-2_1x.jpg"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/4859/screenshots/14198934/gift_inside_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/43602/screenshots/4378613/food-app_1x.png"
                alt=""
              />
            </Link>
            <Link to="/">
              <img
                src="https://cdn.dribbble.com/users/3132/screenshots/2616558/ueno_annouce_1x.jpg"
                alt=""
              />
            </Link>
          </div>
          <button className="btn404">
            <Link to="/">Home</Link>
          </button>
        </div>
      </>
    );
  }
}
